(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/team-page/assets/javascripts/team-page.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/team-page/assets/javascripts/team-page.js');

'use strict';

const {
  useEffect,
  useRef
} = React;
const {
  useRouteMatch,
  useHistory,
  Link
} = ReactRouterDOM;
const ReactButton = svs.ui.ReactButton;
const {
  useDispatch
} = ReactRedux;
const {
  useTeams
} = svs.components.marketplaceCompetition.services.hooks;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useTeamResult
} = svs.components.marketplaceCompetition.services.hooks;
const {
  PersonalResultsTeam
} = svs.components.marketplaceCompetition.routeResult.personalResults;
const {
  Team
} = svs.components.marketplaceCompetition.team;
const {
  TeamCorrectsAndRank
} = svs.components.marketplaceCompetition.teamPage;
const {
  Modal
} = svs.components.lbUi.modal;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  fetchTeams
} = svs.components.marketplaceCompetition.services.actions.teamsActions;
const {
  showDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  Loader
} = svs.components.ReactLoader;
const logger = svs.core.log.getLogger('marketplace-competition:team-page');
const TeamPage = _ref => {
  let {
    currentTeamId
  } = _ref;
  const dispatch = useDispatch();
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const competitionId = useCompetitionId();
  const {
    teams
  } = useTeams(competitionId);
  const {
    params
  } = useRouteMatch();
  const fromJoin = useRef(location.search.includes('fromJoin=true'));
  const timesFetched = useRef(0);
  const refetchInterval = useRef();
  const history = useHistory();
  const teamId = currentTeamId || parseInt(params.teamId, 10);
  const team = teams ? teams[teamId] : {};
  const isLoading = teamId && !teams || !teams[teamId];
  const teamResult = useTeamResult(competitionId, teamId);
  useEffect(() => {
    if (fromJoin.current && isLoading) {
      refetchInterval.current = setInterval(() => {
        if (isLoading && timesFetched.current < 10) {
          timesFetched.current = timesFetched.current + 1;
          dispatch(fetchTeams(competitionId));
        } else {
          if (timesFetched.current >= 10) {
            logger.info("Mkp-competition: Failed refetch team, team invitation retries: 10");
            dispatch(showDialogAction({
              title: 'Vi kunde inte hitta laget just nu',
              text: 'Just nu har vi tekniska problem. Försök igen lite senare.',
              icon: 'exclamation-sign',
              buttons: [{
                text: 'Okej',
                callback: () => {
                  history.push("/tavlingar/".concat(params.competitionName));
                }
              }]
            }));
          }
          logger.info("Mkp-competition: Found team, team invitation retries: ".concat(timesFetched.current));
          clearInterval(refetchInterval.current);
        }
      }, 2000);
    }
    return () => {
      clearInterval(refetchInterval.current);
    };
  }, [competitionId, dispatch, history, isLoading, params.competitionName, teams]);
  if (isLoading) {
    return React.createElement(Loader, {
      inverted: true
    });
  }
  if (!team || !team.data) {
    return null;
  }
  const CloseButton = () => React.createElement("div", {
    className: "team-footer bg-white padding-1"
  }, React.createElement(ReactButton, {
    block: true,
    size: 300,
    transparent: true
  }, React.createElement(Link, {
    className: "qa-to-overview",
    to: "/tavlingar/".concat(params.competitionName, "?focus=team-").concat(teamId)
  }, "St\xE4ng")));
  const content = () => React.createElement("div", {
    className: "team-page qa-team-page"
  }, React.createElement(TeamCorrectsAndRank, {
    team: team,
    teamResult: teamResult
  }), React.createElement("div", {
    className: "team-page-part middle"
  }, React.createElement("h3", {
    className: "team-page-header"
  }, "Individuell st\xE4llning"), Boolean(teamResult === null || teamResult === void 0 ? void 0 : teamResult.data) && React.createElement(PersonalResultsTeam, {
    team: teamResult,
    useScoreItem: false
  }), !(teamResult !== null && teamResult !== void 0 && teamResult.data) && React.createElement("p", {
    className: "no-personal-result"
  }, "St\xE4llning ej tillg\xE4nglig")), React.createElement("div", {
    className: "team-page-part"
  }, React.createElement(Team, {
    teamResult: teamResult
  })), Boolean(isSmall) && React.createElement(CloseButton, null));
  return isSmall ? React.createElement(Modal, {
    isOpen: true
  }, content()) : content();
};
setGlobal('svs.components.marketplaceCompetition.teamPage.TeamPage', TeamPage);

 })(window);